<template>
  <b-badge v-if="status === StatusBulkActionType.type.PROCESSED"
           variant="success">Processado
  </b-badge>
  <b-badge v-else-if="status === StatusBulkActionType.type.ERROR"
           variant="danger">Erro
  </b-badge>
  <b-badge v-else-if="status === StatusBulkActionType.type.PROCESSING"
           variant="warning">Em processamento
  </b-badge>
  <b-badge v-else-if="status === StatusBulkActionType.type.PENDING"
           variant="light">Pendente
  </b-badge>

</template>
<script>
import StatusBulkActionType from "@/model/types/resource/StatusBulkActionType";

export default {
  name: 't-bulk-status-badge',
  data() {
    return {
      StatusBulkActionType,
    }
  },
  props: {
    status: {
      type: Number,
      required: true,
    }
  }
}
</script>